export const TUTORIAL_ROUTE = '/tutoriel';
export const FRONTEND_VERSION = process.env.REACT_APP_VERSION || '';
